// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-d53c6da2] .el-dialog__body{padding:16px!important}[data-v-d53c6da2] .form-wrap .el-form-item{margin:0!important;display:flex;flex-direction:column;gap:4px}[data-v-d53c6da2] .el-form-item:after,[data-v-d53c6da2] .el-form-item:before{display:none}[data-v-d53c6da2] .form-wrap .el-form-item__label{padding:0!important}", ""]);
// Exports
module.exports = exports;
